import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import { Map } from "immutable";
import { Link } from "react-router-dom";
import { INVENTORIES } from "MODULES/inventories/constants";
import {
  DataTable,
  SearchPropTypes,
  PoCode,
  PartNumber
} from "MODULES/shared/components";
import { get } from "lodash";
import { RepairingIcon } from "MODULES/shared/components/InventoryListingOverrideCell/InventoryListingOverrideCell";
import LocationFlag from "MODULES/shared/components/LocationFlag/LocationFlag";
import {
  ADMIN,
  CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST,
  PERMISSIONS,
  ROLE,
  USER
} from "MODULES/users/constants";
import { ID } from "APP_ROOT/constants";
import { shortDate } from "LIB/formatters/date";
import { truncate, getFirstNameLastInitial } from "LIB/formatters/text";
import CartActionButton from "./CartActionButton";

class Table extends Component {
  componentDidMount() {
    const { isAdmin, currentUser, search } = this.props;

    if (!isAdmin) {
      search.setFilters({ reserve_for_seller_id: currentUser.get("id") });
    }
  }

  renderRow = (item, isAdmin, currentUser) => {
    const cantAddToCart =
      !isAdmin &&
      item.reserve_for_seller_id !== currentUser.get(ID) &&
      !currentUser
        .get(PERMISSIONS)
        .includes(CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST);

    const inventoryLink = i => {
      if (i.placeholder) return i.serial_number;
      return (
        <Link to={`/inventories/${i.uuid || i.id}`}>{i.serial_number}</Link>
      );
    };

    return (
      <tr
        className={classNames({ "text-muted": item.cart })}
        key={`sale-list-item-${item.id}`}
      >
        <td>{shortDate(item.reserved_for_sale_on)}</td>
        <td>
          <PartNumber part={item.part} />
        </td>
        <td>{inventoryLink(item)}</td>
        <td>
          <PoCode inventory={item} />
        </td>
        <td>{truncate(item.part.description, 25)}</td>
        <td>
          <LocationFlag
            location={item.store_owner_id}
            consignment_type={item.consignment_type}
          />
        </td>
        <td>
          <LocationFlag location={item.store_location_id} />
          <RepairingIcon inventory={item} />
        </td>
        <td>{INVENTORIES.condition[item.condition].label}</td>
        <td>{item.total_quantity}</td>
        <td>
          {getFirstNameLastInitial(get(item, "reserve_for_seller.full_name"))}
        </td>
        <td>{getFirstNameLastInitial(get(item, "reserved_by.full_name"))}</td>
        <td className="text-center td-shrink-icon">
          <CartActionButton
            item={item}
            disabled={cantAddToCart || item.placeholder}
          />
        </td>
      </tr>
    );
  };

  render() {
    const { currentUser, results, isAdmin, isLoading } = this.props;

    return (
      <DataTable loading={results.length === 0 && isLoading}>
        <DataTable.Head>
          <th>Reserved at</th>
          <th>Part #</th>
          <th>Serial #</th>
          <th>PO #</th>
          <th>Description</th>
          <th>Store Owner</th>
          <th>Store Loc</th>
          <th>Condition</th>
          <th>QTY</th>
          <th>Reserved For</th>
          <th>Reserved By</th>
          <th className="text-center" />
        </DataTable.Head>
        <DataTable.Body>
          {results.map(item => this.renderRow(item, isAdmin, currentUser))}
        </DataTable.Body>
      </DataTable>
    );
  }
}

Table.propTypes = {
  currentUser: PropTypes.instanceOf(Map),
  isAdmin: PropTypes.bool,
  ...SearchPropTypes
};

export default connect(state => ({
  currentUser: state.session.get(USER),
  isAdmin: state.session.getIn([USER, ROLE]) === ADMIN
}))(Table);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/ReserveForSale/Table.jsx